import React, {Component} from 'react';
import { Checkbox, Radio } from 'react-icheck';

class BookPartItemTable extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:this.newEmptyRow(50),checked:{status:new Array(50).fill(false)}}

  }

  newEmptyRow(number=1) {
    return new Array(number).fill({pcy_no:'',list:'',description:'',remark:''})
  }

  componentDidMount() {

  }

  onPartClick(val,index,isPage,e) {
    let _checked = {val:val,index:index,page:isPage}
    this.props.onPartClick(_checked)
  }

  renderRowData() {
    let {selectColumn,data,checked,isPage} = this.props
    if (data.length===0||checked.length===0) {
      return(
        <tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index} style={{backgroundColor:(checked[isPage].pageIndex.indexOf(index)!==-1?'rgb(238, 238, 238)':'')}}>
              <td className='text-center' style={{display:(selectColumn.indexOf('0')!==-1?'':'none')}}>
                <Checkbox
                  onChange={this.onPartClick.bind(this,checked[isPage].pageIndex.indexOf(index),index,isPage)}
                  checked={checked[isPage].pageIndex.indexOf(index)!==-1?true:false}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
                </Checkbox>
              </td>
              <td className='text-center' style={{display:(selectColumn.indexOf('1')!==-1?'':'none')}}>{item.figure_no}</td>
              <td className='text-center' style={{display:(selectColumn.indexOf('2')!==-1?'':'none')}}>{item.productcode}</td>
              <td style={{display:(selectColumn.indexOf('3')!==-1?'':'none')}}>{item.description}</td>
              <td style={{display:(selectColumn.indexOf('4')!==-1?'':'none')}}>{item.description_en}</td>
              <td style={{display:(selectColumn.indexOf('5')!==-1?'':'none')}}>{item.remark}</td>
            </tr>
          )
        })
      )
    }  
  }

  renderTable() {
    let {selectColumn} = this.props
    return(
        <table className='table table-bordered-solid' style={{fontSize:'14px'}}>
          <thead>
            <tr>
              <th className='text-center' style={{width:'5%',display:(selectColumn.indexOf('0')!==-1?'':'none')}}></th>
              <th className='text-center' style={{width:'5%',display:(selectColumn.indexOf('1')!==-1?'':'none')}}>NO.</th>
              <th className='text-center' style={{width:'15%',display:(selectColumn.indexOf('2')!==-1?'':'none')}}>P.C.Y NO.</th>
              <th className='text-center' style={{width:'30%',display:(selectColumn.indexOf('3')!==-1?'':'none')}}>รายการ</th>
              <th className='text-center' style={{width:'30%',display:(selectColumn.indexOf('4')!==-1?'':'none')}}>DESCRIPTION</th>
              <th className='text-center' style={{width:'15%',display:(selectColumn.indexOf('5')!==-1?'':'none')}}>หมายเหตุ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
    )
  }

  render() {
    return(
      this.renderTable()
    )
  }
}  

BookPartItemTable.defaultProps = {
  selectColumn:['0','1','2','3','4','5'],
  data:[],
  checked:[],
  isPage:0
}

export default BookPartItemTable;


// WEBPACK FOOTER //
// ./src/view/book/BookPartItemTable.js